import { useContext } from 'react'
import { UserActionsCore } from './UserActionsContext'

export const useUserActionsContext = () => {
  return useContext(UserActionsCore)
}
